import { AxiosError } from 'axios'
import { axiosInstance } from '../../helpers'
import { Invoice } from '../../models'
import { setNetworkError } from '../error'
import { AppThunk, ErrorResponse } from '../types'
import {
    InvoiceListThunk,
    InvoiceRequest,
    InvoiceActionTypes,
    SET_INVOICE_LOADING,
    GET_INVOICE_LIST_REQUEST,
    SET_INVOICE_LIST,
    SET_COMPANY_INVOICE_LIST,
    InvoiceAxiosRequest,
    UPDATE_INVOICE,
} from './types'

export const getInvoiceList = (
    req: InvoiceAxiosRequest,
    workspaceId?: number,
): AppThunk<InvoiceListThunk> => {
    return async (dispatch) => {
        dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, true))

        const url = `invoice/`

        try {
            const response = await axiosInstance.get(url, req)

            dispatch(setInvoiceList(response.data, workspaceId))
            dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, false))

            return response
        } catch (e) {
            const error = e as AxiosError<ErrorResponse>

            dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, false))
            dispatch(setNetworkError(error, true))

            return new Promise((_, reject) => {
                reject(error)
            })
        }
    }
}

export const getCompanyInvoiceList = (
    req: InvoiceAxiosRequest,
): AppThunk<InvoiceListThunk> => {
    return async (dispatch) => {
        dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, true))

        const url = `invoice/`

        try {
            const response = await axiosInstance.get(url, req)

            dispatch(setCompanyInvoiceList(response.data))
            dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, false))

            return response
        } catch (e) {
            const error = e as AxiosError<ErrorResponse>

            dispatch(setInvoiceLoading(GET_INVOICE_LIST_REQUEST, false))
            dispatch(setNetworkError(error, true))

            return new Promise((_, reject) => {
                reject(error)
            })
        }
    }
}

export const setInvoiceList = (
    invoiceList?: Invoice[],
    workspaceId?: number,
): InvoiceActionTypes => {
    return {
        type: SET_INVOICE_LIST,
        invoiceList: invoiceList,
        workspaceId: workspaceId,
    }
}

export const setCompanyInvoiceList = (
    companyInvoiceList?: Invoice[],
): InvoiceActionTypes => {
    return {
        type: SET_COMPANY_INVOICE_LIST,
        companyInvoiceList: companyInvoiceList,
    }
}

export const updateInvoice = (invoice: Invoice): InvoiceActionTypes => {
    return {
        type: UPDATE_INVOICE,
        invoice: invoice,
    }
}

export const setInvoiceLoading = (
    request: InvoiceRequest,
    isLoading: boolean,
): InvoiceActionTypes => {
    return {
        type: SET_INVOICE_LOADING,
        request: request,
        isLoading: isLoading,
    }
}
